module.exports = "<div class=\"step\" [ngClass]=\"{'next-step': stepThree}\">\r\n  <div class=\"number\">2</div>\r\n  <h2> {{'step-two-title' | translate}} </h2>\r\n  <appointment-slots [potentialAppointmentList]=\"potentialAppointmentList\" [selectedDateFromDatepicker]=\"selectedDateFromDatepicker\" (getMorePotentialAppointments)=\"getMoreSlots($event)\" (selectedSlot)=\"selectSlot($event)\"></appointment-slots>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/strahinja.aparac/Desktop/git/source/healthcare/v2/app/appointment-widget/src/app/step-two/step-two.component.html
// module id = ../../../../../src/app/step-two/step-two.component.html
// module chunks = main